module.exports = __webpack_public_path__ + "img/5高校实验室Bg.d0b64e3b.png";